// Shared preference summary helpers for client detail preferences +
// matches sections (CRM-CLIENT-CONTACTS-MATCHING-A1). No API imports.

const DEAL_TYPE_LABELS = {
  sale: "Продаж",
  rent: "Оренда",
};

const PROPERTY_TYPE_LABELS = {
  apartment: "Квартира",
  house: "Будинок",
  land: "Земля",
  commercial: "Комерція",
  industrial: "Промислова",
};

const hasText = (value) =>
  typeof value === "string" && value.trim().length > 0;

const hasNumber = (value) =>
  value !== null && value !== undefined && value !== "";

const formatPrice = (value) => {
  if (!hasNumber(value)) return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return `$${n.toLocaleString("uk-UA", {
    maximumFractionDigits: 0,
  })}`;
};

const formatArea = (value) => {
  if (!hasNumber(value)) return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return n.toLocaleString("uk-UA", { maximumFractionDigits: 2 });
};

const formatRooms = (value) => {
  if (!hasNumber(value)) return null;
  return String(value);
};

const formatRange = (min, max, formatter, suffix) => {
  const minStr = formatter(min);
  const maxStr = formatter(max);
  if (minStr && maxStr) {
    return suffix
      ? `${minStr} — ${maxStr} ${suffix}`
      : `${minStr} — ${maxStr}`;
  }
  if (minStr) return suffix ? `від ${minStr} ${suffix}` : `від ${minStr}`;
  if (maxStr) return suffix ? `до ${maxStr} ${suffix}` : `до ${maxStr}`;
  return null;
};

export const buildPreferencesSummaryRows = (prefs) => {
  if (!prefs) return [];

  const dealTypeLabel = hasText(prefs.deal_type)
    ? DEAL_TYPE_LABELS[prefs.deal_type] || prefs.deal_type
    : null;
  const propertyTypeLabel = hasText(prefs.property_type)
    ? PROPERTY_TYPE_LABELS[prefs.property_type] || prefs.property_type
    : null;
  const priceLabel = formatRange(prefs.min_price, prefs.max_price, formatPrice);
  const areaLabel = formatRange(
    prefs.min_area,
    prefs.max_area,
    formatArea,
    "м²",
  );
  const roomsLabel = formatRange(prefs.rooms_min, prefs.rooms_max, formatRooms);
  const cityLabel = hasText(prefs.city) ? prefs.city : null;
  const districtLabel = hasText(prefs.district) ? prefs.district : null;

  return [
    dealTypeLabel ? { label: "Тип угоди", value: dealTypeLabel } : null,
    propertyTypeLabel
      ? { label: "Тип нерухомості", value: propertyTypeLabel }
      : null,
    priceLabel ? { label: "Ціна", value: priceLabel } : null,
    areaLabel ? { label: "Площа", value: areaLabel } : null,
    roomsLabel ? { label: "Кімнат", value: roomsLabel } : null,
    cityLabel ? { label: "Місто", value: cityLabel } : null,
    districtLabel ? { label: "Район", value: districtLabel } : null,
  ].filter(Boolean);
};
